import React from 'react';
import ReactDOM from 'react-dom';
import './global'; //this needs to be here because it needs to be loaded before redux
import { Provider } from 'react-redux';
import configureStore from './redux/create';
import { addLocaleData, IntlProvider, FormattedMessage } from 'react-intl';
import nl from 'react-intl/locale-data/nl';
import language from './languages/nl';


import { App, Widget } from 'components';

import './fonts/Alijt/stylesheet.scss';
import './fonts/BrandonGrotesque/stylesheet.scss';
import './fonts/Andrea/stylesheet.scss';
import './fonts/Baskerville/stylesheet.scss';
import './fonts/Luna/stylesheet.scss';
import './fonts/Quicksand/stylesheet.scss';
import './fonts/ProximaNova/stylesheet.scss';
import './fonts/Rollerscript/stylesheet.scss';
import './fonts/Professor/stylesheet.scss';
import './fonts/PlayfairDisplay/stylesheet.scss';
import './fonts/FiraSans/stylesheet.scss';

const initialState = window.__data || {};
const store = configureStore(initialState);

export const container = document.getElementById('app');
export const isWidgetContainer = container && 'widget' in container.dataset;

addLocaleData([...nl]);

// addLocaleData(nl);
// addLocaleData({
// 	locale: 'nl',
// 	parentLocale: 'nl',
// });
// const { locale, messages } = window.App;
const Root = () =>
  isWidgetContainer ? (
    <IntlProvider locale="nl" message={language}>
      <Widget />
    </IntlProvider>
  ) : (
    <Provider store={store}>
      <IntlProvider locale="nl">
        <App />
      </IntlProvider>
    </Provider>
  );

export default Root;

if (!module.hot && container) {
  ReactDOM.render(<Root />, container);
}



// WEBPACK FOOTER //
// ./app/index.js